export default __webpack_public_path__ + "pin-shake-chrome-extension.png";